import classNames from "classnames";

type PageLayoutProps = {
  children: React.ReactNode;
  className?: string;
};

const PageLayout = ({ children, className }: PageLayoutProps) => {
  const wrapper = "wrapper mt-4 md:mt-8 mb-8 md:mb-16";
  const grid =
    "grid grid-cols-16 md:grid-cols-12 lg:grid-cols-16 gap-x-4 md:gap-x-8 gap-y-8 md:gap-y-16";

  const classes = classNames(wrapper, grid, className);
  return (
    <div className={classes} data-testid="page-layout-wrapper">
      {children}
    </div>
  );
};

export default PageLayout;
